import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import type { AppUser } from "../../features/auth/hooks";
import { Avatar } from "../ui/Avatar";

type AppHeaderProps = {
  user: AppUser | null;
};

export function AppHeader({ user }: AppHeaderProps) {
  const { t } = useTranslation();
  // No hamburger: bottom tabs cover primary nav; Profile holds info pages
  // (About / Privacy / How-to / Settings / Favorites). Centered wordmark
  // replaces the three-zone hamburger / logo / avatar layout. Avatar links
  // to the Profile tab so users still have a one-tap path to account.
  return (
    <header className="sticky top-0 z-20 grid h-14 grid-cols-[1fr_auto_1fr] items-center border-b border-line bg-bg-deep px-3">
      <div />
      <Link to="/" className="justify-self-center text-base font-bold tracking-tight text-volt">
        VoltaRoute
      </Link>
      <Link to="/profile" aria-label={t("nav.tab_profile")} className="justify-self-end">
        <Avatar userId={user?.id ?? null} label={user?.email ?? null} size={32} />
      </Link>
    </header>
  );
}
